import { useInView } from "react-intersection-observer";

/**
 * Progressive scroll reveal.
 *
 * Content stays visible until IntersectionObserver has actually produced an
 * entry. CSS only enables the hidden/reveal states on desktop and when motion
 * is allowed, so mobile/tablet and reduced-motion users never depend on the
 * observer to access content.
 */
function useScrollReveal(options = {}) {
  const { ref, inView, entry } = useInView({
    triggerOnce: true,
    fallbackInView: true,
    ...options,
  });

  return {
    ref,
    revealProps: {
      "data-reveal-observed": entry ? "true" : "false",
      "data-reveal-visible": inView ? "true" : "false",
    },
  };
}

export default useScrollReveal;
